export default class InvalidMfaCodeError extends Error {
  constructor(message) {
    super(message)
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, InvalidMfaCodeError)
    }
    this.name = 'InvalidMfaCodeError'
    // Custom debugging information
    this.errorDate = new Date()
  }
}
